import { Tag } from "@/components/elements/Tag";
import { pink, state } from "@/theme/colors";
import { DOCUMENT_STATUS, DOCUMENT_STATUS_LABEL } from "@/types/enum";
import { FC, useMemo } from "react";

export type TDocumentStatusTagProps = {
  status: string;
};

export const DocumentStatusTag: FC<TDocumentStatusTagProps> = ({ status }) => {
  const tagProps = useMemo(() => {
    switch (status) {
      case DOCUMENT_STATUS.IN_PROGRESS:
        return { color: state.warning_1 };
      case DOCUMENT_STATUS.COMPLETE:
        return { color: state.success_1 };
      case DOCUMENT_STATUS.CONVERTING:
        return { color: pink[70] };
      case DOCUMENT_STATUS.COMPLETED_CONVERT:
        return { color: state.success_1 };
      case DOCUMENT_STATUS.CONVERT_COMPLETE:
        return { color: state.success_1 };
      case DOCUMENT_STATUS.ERROR:
        return { color: state.error_1 };
      default:
        return { color: state.success_1 };
    }
  }, [status]);

  return <Tag title={DOCUMENT_STATUS_LABEL[status]} variant="bold" textColor="white" {...tagProps} />;
};
